import { useRef } from 'react';

export const useScrollToElement = (scrollTopOffset: number) => {
  const elementRef = useRef(null);

  const scrollToElement = () => {
    const scrollTop =
      elementRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      (scrollTopOffset + 10); // 10px buffer to account spacing between the element and the top of the viewport

    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });
  };

  return { elementRef, scrollToElement };
};
